// extracted by mini-css-extract-plugin
module.exports = {"landingContainer":"styles_landingContainer__dTDx4"};